import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { Box, Button, Typography } from '@mui/material';
import moment from 'moment';
import Link from 'next/link';
import { BlogPost } from 'src/logic/models/blog';
import { sm } from 'src/site-map';

type IProps = {
  post: BlogPost;
};

const BlogPostCard = ({ post }: IProps) => {
  return (
    <Box
      sx={{
        backgroundColor: '#fff',
        borderRadius: '20px',
        boxShadow: '0px 0px 40px 0px #0017721A',
        p: 2,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <div>
        <img
          src={`${post.cover_photo_path}?v=${post.id}`}
          alt={post.photo_alt_text}
          style={{
            display: 'block',
            borderRadius: '10px',
            objectFit: 'cover',
            objectPosition: 'center',
            width: '100%',
            height: '175px',
          }}
        />
        <Typography
          fontSize={{
            xs: 8,
            lg: 11,
          }}
          fontWeight={700}
          textTransform={'uppercase'}
          color='#fff'
          sx={{
            backgroundColor: '#0F5D85',
            borderRadius: '30px',
            display: 'inline-block',
            py: 1,
            px: 2,
            letterSpacing: '2px',
            my: 2,
          }}
        >
          {moment(post.published_at, 'DD-MM-YYYY').format('ll')}
        </Typography>
        <Typography
          color='#070A0D'
          fontWeight={600}
          fontSize={{ xs: 16, lg: 20 }}
          lineHeight={1.25}
          component='h3'
          sx={{
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 3,
            overflow: 'hidden',
          }}
        >
          {post.title}
        </Typography>

        {post.sub_title && (
          <Typography
            color='#1D2935'
            fontWeight={400}
            fontSize={{ xs: 12, lg: 16 }}
            lineHeight={1.25}
            mt={1}
            sx={{
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 3,
              overflow: 'hidden',
            }}
          >
            {post.sub_title}
          </Typography>
        )}
      </div>
      <Box display={'flex'} justifyContent={'end'} mt={2}>
        <Link href={sm.blog.post(post.slug).url} passHref>
          <Button
            type='button'
            endIcon={<ArrowRightAltIcon />}
            sx={{
              color: '#0F5D85',
              fontWeight: 600,
            }}
          >
            Read This Article
          </Button>
        </Link>
      </Box>
    </Box>
  );
};

export default BlogPostCard;
